var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 24,
    cy: 24,
    r: 23.5,
    fill: "#6695FB",
    stroke: "#DADADA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_209_18730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 12C17.4489 12 17.6397 12.079 17.7803 12.2197C17.921 12.3603 18 12.5511 18 12.75V13.5H30V12.75C30 12.5511 30.079 12.3603 30.2197 12.2197C30.3603 12.079 30.5511 12 30.75 12C30.9489 12 31.1397 12.079 31.2803 12.2197C31.421 12.3603 31.5 12.5511 31.5 12.75V13.5H33C33.7956 13.5 34.5587 13.8161 35.1213 14.3787C35.6839 14.9413 36 15.7044 36 16.5V33C36 33.7956 35.6839 34.5587 35.1213 35.1213C34.5587 35.6839 33.7956 36 33 36H15C14.2044 36 13.4413 35.6839 12.8787 35.1213C12.3161 34.5587 12 33.7956 12 33V16.5C12 15.7044 12.3161 14.9413 12.8787 14.3787C13.4413 13.8161 14.2044 13.5 15 13.5H16.5V12.75C16.5 12.5511 16.579 12.3603 16.7197 12.2197C16.8603 12.079 17.0511 12 17.25 12V12ZM13.5 18V33C13.5 33.3978 13.658 33.7794 13.9393 34.0607C14.2206 34.342 14.6022 34.5 15 34.5H33C33.3978 34.5 33.7794 34.342 34.0607 34.0607C34.342 33.7794 34.5 33.3978 34.5 33V18H13.5Z",
    fill: "#6493F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_209_18730"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard3);
export default __webpack_public_path__ + "static/media/dashboard3.cb870fcab4c3f565668af3308d8cfe2b.svg";
export { ForwardRef as ReactComponent };